import { getCode } from 'country-list';
import { Injectable } from '@angular/core';
import { filterNilValue, Query } from '@datorama/akita';
import { SettingsStore, SettingsState } from './settings.store';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { Currency } from '../../../shared/components/currency-selector/currency-country-codes';
import { code } from 'currency-codes';

@Injectable({ providedIn: 'root' })
export class SettingsQuery extends Query<SettingsState> {
    availableCurrencies$ = this.select('currenciesAndRates').pipe(
        map((currenciesAndRates) => Object.keys(currenciesAndRates) as Array<Currency>),
        shareReplay(1)
    );

    availableCountries$ = this.availableCurrencies$.pipe(
        map((availableCurrencies) =>
            availableCurrencies
                .reduce((acc, currency: Currency) => {
                    return [
                        ...acc,
                        ...code(currency).countries.map((name) => {
                            name = name.replace(/ \(The\)/, '');
                            const iso = getCode(name);
                            const flag = iso?.toLowerCase();
                            return { iso, flag, name };
                        })
                    ];
                }, [])
                .filter((country) => country.iso)
                .sort()
        ),
        shareReplay(1)
    );

    currenciesAndRates$ = this.select('currenciesAndRates').pipe(
        filterNilValue(),
        distinctUntilChanged(
            (previous, current) => JSON.stringify(current) === JSON.stringify(previous)
        ),
        shareReplay(1)
    );

    getRate = (currency: string) => this.getValue().currenciesAndRates[currency];

    constructor(protected store: SettingsStore) {
        super(store);
    }
}
